import { Check, CheckCircle } from "@phosphor-icons/react";
import { phaseRegistry } from "../registry.js";
import { PhaseTile } from "../components.js";
import { ItemTable } from "../table.js";
import {
  EmptyState,
  EmptyStateIcon,
  EmptyStateTitle,
} from "@/components/ui/empty-state";

const SignoffPage = () => {
  return (
    <ItemTable
      search="phase:signoff"
      emptyState={
        <EmptyState>
          <EmptyStateIcon>
            <CheckCircle />
          </EmptyStateIcon>
          <EmptyStateTitle>No items to sign off.</EmptyStateTitle>
        </EmptyState>
      }
    />
  );
};

const SignoffTile = () => {
  return (
    <PhaseTile phase="signoff">
      <Check size={24} />
    </PhaseTile>
  );
};

phaseRegistry.register({
  type: "signoff",
  order: 3,
  page: SignoffPage,
  tile: SignoffTile,
});
